export default __webpack_public_path__ + "img/25f1b9e919d5f8e96f06c046b6a9d0b2.svg";